<template>
  <a-layout>
    <a-space>
      <a-input-search
        class="query"
        @pressEnter="getData"
        @search="getData"
        :placeholder="$t('business.label.itemNo')"
        v-model="query['item.no']"
      />
      <a-input-search
        class="query"
        @pressEnter="getData"
        @search="getData"
        :placeholder="$t('business.label.itemName')"
        v-model="query['item.name']"
      />
      <a-input-search
        class="query"
        @pressEnter="getData"
        @search="getData"
        :placeholder="$t('business.label.lot')"
        v-model="query['lot.no']"
      />
      <a-button type="primary" @click="getData">{{ $t('button.query') }}</a-button>
      <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
      <a-button type="primary" @click="printShelf">{{ $t('button.printShelfLabel') }}</a-button>
      <a-button type="primary" @click="printReject">{{ $t('button.printRejectLabel') }}</a-button>
    </a-space>
    <br />
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}">
      <vxe-column fixed="left" type="checkbox" width="60" />
      <vxe-column field="item.no" title="business.label.itemNo" width="80" />
      <vxe-column field="item.name" title="business.label.itemName" width="200" />
      <vxe-column field="pack.specification" title="business.label.specification" width="200" />
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="lot.no" title="business.label.lot" width="150" />
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150" />
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="detail.receivingman" title="business.label.receiver" width="150" />
      <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="150" />
      <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="150" />
      <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="150" />
    </vxe-table>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import { DeviceHandler } from '@/deviceHelper'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ReceiptPrintDetail',
  data() {
    return {
      data: [],
      loading: false,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'order.id': '',
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.4)
    }
  },
  methods: {
    pageChange(e) {
      this.page = e.page
      this.size = e.size
      this.getData()
    },
    getData(args) {
      if (args !== null && args !== undefined) {
        Object.assign(this.query, args)
      }
      if (this.query['order.id'] === '' || this.query['order.id'] === undefined || this.query['order.id'] === null) {
        return this.$message.warning('请先选择单据')
      }
      this.loading = true
      findAll('receivingTagFactory', this.query).then(res => {
        if (res.success) {
          let i = 1
          res.result.forEach(item => {
            item.key = i++
          })
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    clear() {
      this.data = []
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.query['order.id'] = ''
      this.page = 1
    },
    reset() {
      this.query['item.no'] = ''
      this.query['item.name'] = ''
      this.query['lot.no'] = ''
      this.page = 1
      this.getData()
    },
    printShelf() {
      let selectedRows= this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请先选择需要打印的数据')
      }
      let notPrint = []
      let print = []
      selectedRows.forEach(item => {
        if (!item.command) {
          notPrint.push(item.key)
        } else {
          print.push(item.command.commandGroup)
        }
      })
      if (notPrint.length > 0) {
        notPrint.sort((a, b) => a - b)
        this.$info({
          title: '第' + notPrint.join(',') + '条明细未验收,无法打印上架标签',
          content: '需验收后打印',
          onOk() {
          },
          onCancel() {
          },
          centered: true
        })
      }
      if (print.length > 0) {
        this.printData(print)
      }

    },
    printData(data) {
      data.forEach(item => {
        const body1 = {
          'query.no': 'receivingCheckPrint',
          sql: null,
          args: {
            commandGroup: item
          }
        }
        post(api.adminQuery, {}, body1).then(res => {
          if (res.result.length > 0) {
            let Dt = []
            res.result.map(data => {
              data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
              data.spmcgg = data.spmc + ' / ' + data.gg
              data.phxq = data.ph + ' / ' + data.xq
              data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
              data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
              data.dhrq = data.asnNo + ' / ' + data.scrq
              data.bdm = data.pzwh + '箱数量：' + parseInt(data.bzs).toFixed(1) + ' / ' + data.fdsx
              data.shy=data.shy? data.shy:''
              data.sjhw=data.sjhw? data.sjhw:''
              data.cctj=data.cctj? data.cctj:''
              Dt.push(data)
            })
            if (Dt.length > 0) {
              const printList = []
              printList.push(
                {
                  'PLAN_CODE': '080027',
                  'WH_ID': 1000000001,
                  'DATA': Dt
                }
              )
              DeviceHandler.printWithDataList(printList, (q, res) => {
                post(api.receivingReceiverPrintUpdate, {}, { commandGroup: item })
              })
            }
          } else {
            this.$message.warning('无可打印数据')
          }
        })
      })

    },
    printReject() {
      let selectedRows= this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请先选择需要打印的数据')
      }
      let unPrintsIndex = []
      let receiptRejectPrintRows = []
      let inspectRejectPrintRows = []
      selectedRows.forEach(cmd => {
        if (cmd.detail.rejectedQuantity + cmd.detail.rejectedQuantityOfAcceptance === 0) {
          unPrintsIndex.push(cmd.key)
        }
        if (cmd.detail.rejectedQuantity > 0) {
          receiptRejectPrintRows.push(cmd)
        }
        if (cmd.detail.rejectedQuantityOfAcceptance > 0) {
          inspectRejectPrintRows.push(cmd)
        }
      })
      if (unPrintsIndex.length > 0) {
        unPrintsIndex.sort((a, b) => a - b)
        this.$info({
          title: '第' + unPrintsIndex.join(',') + '条明细未拒收,无法打印拒收标签',
          content: '需拒收后打印',
          onOk() {
          },
          onCancel() {
          },
          centered: true
        })
      }
      console.log(receiptRejectPrintRows)
      console.log(inspectRejectPrintRows)
    }
  }
}
</script>